import axios from 'axios';
import { serverConfig } from './server-config';

export const CareerGuidanceService = {

    getSessions: (page = 0, size = 10) => {
        return axios.get(
            `https://${serverConfig.serverBaseAddress}/signite/career-guidance/sessions`,
            {
                params: {
                    page: page,
                    size: size
                },
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('authToken'),
                },
            }
        );
    },

    getSlots: (sessionId, page = 0, size = 10) => {
        return axios.get(
            `https://${serverConfig.serverBaseAddress}/signite/career-guidance/sessions/${sessionId}/slots`,
            {
                params: {
                    page: page,
                    size: size
                },
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('authToken'),
                },
            }
        );
    },

    getPublicSessions: (page = 0, size = 10) => {
        return axios.get(
            `https://${serverConfig.serverBaseAddress}/signite/career-guidance/public/sessions`,
            {
                params: {
                    page: page,
                    size: size
                }
            }
        );
    },

    getPublicSlots: (sessionId, page = 0, size = 10) => {
        return axios.get(
            `https://${serverConfig.serverBaseAddress}/signite/career-guidance/public/sessions/${sessionId}/slots`,
            {
                params: {
                    page: page,
                    size: size
                }
            }
        );
    },

    getPublicCareerGuidanceImage: (path) => {
        return axios.get(
            `https://${serverConfig.serverBaseAddress}/signite/file/public/career-guidance`,
            {
                params: {
                    path: path
                },
                responseType: 'blob'
            }
        );
    },

    // Create Session
    createSession: (data) => {
        return axios.post(
            `https://${serverConfig.serverBaseAddress}/signite/internal-user-actions/career-guidance/sessions`,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('authToken'),
                },
            }
        );
    },

    uploadSessionImage: (file) => {
        const formData = new FormData();
        formData.append("file", file);

        return axios.post(
            `https://${serverConfig.serverBaseAddress}/signite/internal-user-actions/career-guidance/sessions/image`,
            formData,
            {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('authToken'),
                    'Content-Type': 'multipart/form-data'
                },
            }
        );
    },

    updateSession: (sessionId, data) => {
        return axios.put(
            `https://${serverConfig.serverBaseAddress}/signite/internal-user-actions/career-guidance/sessions/${sessionId}`,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('authToken'),
                },
            }
        );
    },

    addSlot: (sessionId, data) => {
        return axios.post(
            `https://${serverConfig.serverBaseAddress}/signite/internal-user-actions/career-guidance/sessions/${sessionId}/slots`,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('authToken'),
                },
            }
        );
    },

    updateSlot: (slotId, data) => {
        return axios.put(
            `https://${serverConfig.serverBaseAddress}/signite/internal-user-actions/career-guidance/slots/${slotId}`,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('authToken'),
                },
            }
        );
    },

    purchaseSession: (data) => {
        return axios.post(
            `https://${serverConfig.serverBaseAddress}/signite/career-guidance/purchase`,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('authToken'),
                },
            }
        );
    },

    getBookings: (page = 0, size = 10) => {
        return axios.get(
            `https://${serverConfig.serverBaseAddress}/signite/career-guidance/bookings`,
            {
                params: {
                    page: page,
                    size: size
                },
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('authToken'),
                },
            }
        );
    },

    getAllBookings: (page = 0, size = 10) => {
        return axios.get(
            `https://${serverConfig.serverBaseAddress}/signite/internal-user-actions/career-guidance/bookings`,
            {
                params: {
                    page: page,
                    size: size
                },
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('authToken'),
                },
            }
        );
    },

};